var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0155 21.6537L6.59625 20.2344L14.8308 11.9999L6.59625 3.76544L8.0155 2.34619L17.6693 11.9999L8.0155 21.6537Z",
    fill: "#1A1A1A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon_next.f911e9ba3da4bd977eb2daa4dba0e0b2.svg";
export { ForwardRef as ReactComponent };